import moment from 'moment'
import { forEach } from 'lodash'
import type {
  RouteLocationNormalized,
  RouteLocationNormalizedLoaded,
  NavigationGuardNext,
} from 'vue-router'

export default class ForceTypes implements App.Middleware.Instance {
  async handle(
    to: RouteLocationNormalized,
    from: RouteLocationNormalizedLoaded,
    next: App.Middleware.Caller,
    cancel: NavigationGuardNext,
  ): Promise<void> {
    // @ts-expect-error
    forEach(to.params, (param: string, key: string) => {
      if (param === null || param === undefined || param === '') {
        // @ts-expect-error
        return (to.params[key] = undefined)
      }
      // @ts-expect-error
      if (!isNaN(param)) {
        // @ts-expect-error
        return (to.params[key] = Number(param))
      }
      if (moment(param).isValid()) {
        // @ts-expect-error
        return (to.params[key] = moment(param))
      }
      if (param === 'true' || param === 'false') {
        const booleanParam = param === 'true'
        if (typeof booleanParam === 'boolean') {
          // @ts-expect-error
          return (to.params[key] = booleanParam)
        }
      }
    })

    await next(to, from, cancel)
  }
}
